import { Flex, Heading, IconName, Paragraph } from '../../atoms';
import { SquareIcon } from './square-icon';

export type SquareIconColorSchemeType = 'blue' | 'green' | 'lightBlue';

const handler: {
  [key in SquareIconColorSchemeType]: {
    iconColor: string;
    backgroundColor: string;
  };
} = {
  blue: { iconColor: 'palette_blue.100', backgroundColor: 'palette_blue.10' },
  green: {
    iconColor: 'palette_success.100',
    backgroundColor: 'palette_success.5'
  },
  lightBlue: {
    iconColor: 'palette_blue.100',
    backgroundColor: 'palette_blue.5'
  }
};

export function SquareIconHeading({
  iconName,
  title,
  colorScheme,
  isOptional = false,
  extraLabel
}: {
  iconName?: IconName;
  title: string;
  colorScheme?: SquareIconColorSchemeType;
  isOptional?: boolean;
  extraLabel?: string;
}): JSX.Element {
  const colors = handler[colorScheme ?? 'blue'];
  return (
    <Flex mb="space_unit.x2" alignItems="center">
      {iconName && (
        <SquareIcon
          backgroundColor={colors.backgroundColor}
          iconProps={{ color: colors.iconColor, name: iconName }}
          mr="space_unit.x2"
        />
      )}
      <Heading variant="h4">{title}</Heading>
      {isOptional && extraLabel && (
        <Paragraph color="palette_gray.60" size="sm" ml="space_unit.x1">
          {`(${extraLabel})`}
        </Paragraph>
      )}
    </Flex>
  );
}
